import { render, staticRenderFns } from "./ItemSelector.vue?vue&type=template&id=20f578be&scoped=true"
import script from "./ItemSelector.vue?vue&type=script&lang=js"
export * from "./ItemSelector.vue?vue&type=script&lang=js"
import style0 from "./ItemSelector.vue?vue&type=style&index=0&id=20f578be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f578be",
  null
  
)

export default component.exports